export default __webpack_public_path__ + "images/inmarket-logo-small.08db34ccbac4aa857e4c5892c5bbddfc.png";